/**
 * Created by Ning Jiang on 2021-09-17.
 */

import {TombstoneRip} from "../TombstoneRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Layers, TombstoneRipLayers} from "./TombstoneRipLayers";
import {TombstoneRipReelView} from "../reels/TombstoneRipReelView";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";

export class XBetButton extends GuiButton {

    private _base:PIXI.Sprite;

    constructor() {
        super("xBetButton");

        this._base = new PIXI.Sprite(TombstoneRip.assetLoader.getTextures("reel2button/Button_inactive")[0]);
        this._base.anchor.set(0.5, 0.2);
        this._base.alpha = 0;
        this.addChild(this._base);

        this.hitArea = new PIXI.Rectangle(-70, -38, 140, 50);
    }
}

export class XBetController extends PIXI.Container {

    public static boostedName:string = "BOOSTED_BET";

    private _button:XBetButton;
    private _effectNormal:PIXI.spine.Spine;
    private _effectBlend:PIXI.spine.Spine;

    public boostedName:string = "BOOSTED_BET";
    private _boostedData:any;

    private _featureAllowed:boolean;
    private _isFreeBet:boolean;

    private _featureVisible:boolean = false;
    public set featureVisible(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        if(this._isFreeBet) {
            return;
        }

        this._featureVisible = value;
        this._button.visible = value;
        this._effectNormal.visible = value;
        this._effectBlend.visible = value;
    }

    public set buttonEnabled(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        if(this._isFreeBet) {
            return;
        }

        if(SlotGame.apiPlugin.isReplay) {
            value = false;
        }

        this._button.enable(value);
        this._effectNormal.tint = value ? 0xffffff : 0x888888;
    }

    private _selected:boolean;
    public set selected(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        this._selected = value;

        const entry = this._effectBlend.state.getCurrent(0);
        if(this._selected && this._featureVisible) {
            if(entry && (entry.animation.name.includes("loop") || entry.animation.name.includes("on"))) {
                return;
            }
            TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.ENHANCE_ON});
            this._effectNormal.state.setAnimation(0, "on", false);
            this._effectBlend.state.setAnimation(0, "on", false);
            const tl = new TimelineLite();
            tl.add(() => {
                if(this._selected && this._featureVisible) {
                    this._effectBlend.state.setAnimation(0, "loop", true);
                }
            }, this._effectBlend.spineData.findAnimation("on").duration);
        } else {
            if(entry) {
                if(entry.animation.name === "off") {
                    return;
                }
            } else {
                if(!TombstoneRip.model.parsedGameData) {
                    const aniName = this._selected ? "on" : "off";
                    this._effectNormal.state.setAnimation(0, aniName, false).time = this._effectNormal.spineData.findAnimation(aniName).duration;
                    this._effectBlend.state.setAnimation(0, aniName, false).time = this._effectBlend.spineData.findAnimation(aniName).duration;
                    if(this._selected) {
                        this._effectBlend.state.setAnimation(0, "loop", true);
                    }
                    return;
                }
            }
            if(this._featureVisible) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.ENHANCE_OFF});
                this._effectNormal.state.setAnimation(0, "off", false);
                this._effectBlend.state.setAnimation(0, "off", false);
            }
        }
    }

    public get selected() {
        return this._selected;
    }

    constructor() {
        super();

        this._featureAllowed = SlotGame.apiPlugin.betFeatureController.isFeatureAllowed("BOOSTED_BET");
        if(!this._featureAllowed) {
            return;
        }

        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_START, () => this.onFreeBets(true));
        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => this.onFreeBets(false));
        // SlotGame.apiPlugin.freeBets.events.on("extFreeRoundsEnded", () => this.onFreeBets(false));

        this._effectBlend = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("reel2ButtonBlend"));
        this._effectBlend.autoUpdate = true;
        this._effectBlend.visible = false;
        this.addChild(this._effectBlend);

        this._effectNormal = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("reel2ButtonNormal"));
        this._effectNormal.autoUpdate = true;
        this._effectNormal.visible = false;
        TombstoneRipLayers.getLayer(Layers.ENHANCED_BUTTON)?.addChild(this._effectNormal);

        this._button = new XBetButton();
        this._button.y = 15;
        this.addChild(this._button);
        this._button.addClickCallback(() => {
            SlotGame.apiPlugin.betHandler.setBoost(!this.selected ? this._boostedData : null);
        });

        this.setPosition(TombstoneRipReelView.REEL_AREAS[1].x, TombstoneRipReelView.REEL_AREAS[1].y + TombstoneRipReelView.REEL_AREAS[1].height + 20);
        TombstoneRipLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this);

        const featureData = SlotGame.apiPlugin.bonusFeatures.getFeatureDataByName(this.boostedName);
        if(featureData) {
            this._boostedData = {featureName : this.boostedName, price : featureData.price};
        }
        SlotGame.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => this.onSelectedFeatureBetChanged());
    }

    private setPosition(x:number, y:number):void {
        this.position.set(x, y);
        this._effectNormal.position.set(x, y);
    }

    private onSelectedFeatureBetChanged():void {
        const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();

        if(activeBetFeature && XBetController.boostedName == activeBetFeature.name) {
            this.selected = XBetController.boostedName == activeBetFeature.name;
        } else {
            this.selected = false;
        }
    }

    private onFreeBets(value:boolean):void {
        if(value) {
            this.featureVisible = false;
            this._isFreeBet = true;
        } else {
            this._isFreeBet = false;
            this.featureVisible = true;
            this.buttonEnabled = true;
            this.onSelectedFeatureBetChanged();
        }
    }

    public start():void {
        if(!this._featureAllowed) {
            return;
        }

        const nextMode = TombstoneRip.model.data.nextMode;
        this.featureVisible = nextMode === GameMode.NORMAL || nextMode === GameMode.RESPIN;
        this.onSelectedFeatureBetChanged();
    }
}
